import {
  Dialog,
  AppBar,
  Typography,
  Grid,
  Slide,
  Theme,
  List,
  Checkbox,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  IconButton,
  Divider,
  Stack,
  TextField,
} from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { TransitionProps } from "@mui/material/transitions";
import React, { useContext, useEffect, useState } from "react";
import { GlobalLoaderContext } from "../../../../context/global-loader";
import { SnackbarContext } from "../../../../context/snackbar";
import { Platform } from "../../../../models/publishing/platform";
import ApiUri from "../../../../api/api-uri";
import API from "../../../../api/api";
import { CompositionPlatform } from "../../../../models/composition/composition-platform";
import CustomToolbar from "../../../../components/layout/titles/CustomToolbar";
import { Close } from "@mui/icons-material";
import { Composition } from "../../../../models/composition/composition";
import { Song } from "../../../../models/song/song";
import useAvailablePlatforms from "../../../../hooks/publishing-platform/availablePlatforms.hook";
import ContextMenu from "./context-menu";
import ContextMenuPlatform from "./context-menu-platforms";
import ActionButtonSmall from "../../../../components/layout/buttons/action-button-small";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      minHeight: "300px",
    },
    appBar: {
      position: "relative",
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
  }),
);

const Transition = React.forwardRef(function Transition(
  // made children required
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface IUpcDialog {
  dialogOpened: boolean;
  onCloseDialog: Function;
  composition: Composition;
  setSongs: any;
}

export default function UpcDialog({
  dialogOpened,
  onCloseDialog,
  composition,
  setSongs,
}: IUpcDialog) {
  const classes = useStyles();
  const { startGlobalLoader, stopGlobalLoader } =
    useContext(GlobalLoaderContext);
  const { initSnackbarError, initSnackbarSuccess } =
    useContext(SnackbarContext);
  const [upc, setUpc] = useState(
    composition.upc_code ? composition.upc_code : "",
  );

  const saveCode = () => {
    startGlobalLoader();

    API.patch(ApiUri.COMPOSITION + "/" + composition.id + ApiUri.UPC_CODE, {
      upc_code: upc,
    }).then(
      (response) => {
        stopGlobalLoader();
        setSongs(null);
        initSnackbarSuccess("UPC Code updated");
      },
      (err) => {
        stopGlobalLoader();
        initSnackbarError(err);
      },
    );
  };

  const closeDialog = () => {
    onCloseDialog();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={dialogOpened}
      onClose={closeDialog}
      TransitionComponent={Transition}
      className={classes.dialog}
    >
      <AppBar className={classes.appBar}>
        <CustomToolbar>
          <Typography variant="h6" className={classes.title}>
            {`Edit UPC Code`}
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={closeDialog}
            aria-label="close"
            size="large"
          >
            <Close />
          </IconButton>
        </CustomToolbar>
      </AppBar>
      <Grid container spacing={2} style={{ padding: 20 }}>
        <Grid item xs={12}>
          <Stack direction="row" spacing={2}>
            <TextField
              label="UPC Code"
              value={upc}
              onChange={(e) => setUpc(e.target.value)}
              fullWidth
            />
            <ActionButtonSmall onClick={saveCode}>Save</ActionButtonSmall>
          </Stack>
        </Grid>
      </Grid>
    </Dialog>
  );
}
